// extracted by mini-css-extract-plugin
export default {"wrapper":"BindAccount_wrapper__Wk+hu"};